"use strict";

module.exports =` 
    <li class="previous disabled"><i class="arrow left"></i></li>
    <li class="next disabled"><i class="arrow right"></i></li>
`;